import 'intersection-observer';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './components/App/App';
import configureStore from './configureStore';
import './css/reset.css';
import './components/Lander/lander-pw.scss';
import './components/App/switcher-styles.css';
import './css/var-queries.scss';
import './css/content-pair.scss';

const { store } = configureStore(window.REDUX_STATE);

const render = (App) => {
  const root = document.getElementById('root');

  ReactDOM.hydrate(
    <Provider store={store}>
      <App />
    </Provider>,
    root,
  );
};

render(App);
